// TODO: Need better solution for this
const API_URL = process.env.API_URL;

export default {
	uriLogin(id = "") {
		console.log("url", API_URL);
		return `${API_URL}/auth/login/${id}`;
	},

	uriAnalytics() {
		return `${API_URL}/statistics/dashboard`;
	},

	uriVehicleConsumptionAverage() {
		return `${API_URL}/statistics/vehicle-consumption-average`;
	},

	uriLogs(id = "") {
		return `${API_URL}/statistics/logs/${id}`;
	},

	uriLogout() {
		return `${API_URL}/auth/logout`;
	},

	uriStaff(id = "") {
		return `${API_URL}/staff/${id}`;
	},

	uriRecoverPassword(id = "") {
		return `${API_URL}/staff/recover-password/${id}`;
	},

	uriStaffPassword() {
		return `${API_URL}/staff/password`;
	},

	uriStaffEmail() {
		return `${API_URL}/staff/email`;
	},

	uriPages(id = "") {
		return `${API_URL}/pages/${id}`;
	},

	uriEmailTemplate(id = "") {
		return `${API_URL}/email-templates/${id}`;
	},

	uriUsers(id = "") {
		return `${API_URL}/users/${id}`;
	},

	uriNotifications(id = "") {
		return `${API_URL}/notifications/${id}`;
	},

	uriCountries(id = "") {
		return `${API_URL}/countries/${id}`;
	},

	uriSettings() {
		return `${API_URL}/settings/`;
	},

	uriCustomers(id = "") {
		return `${API_URL}/customers/${id}`;
	},

	uriSuppliers(id = "") {
		return id ? `${API_URL}/workshop/suppliers/${id}` : `${API_URL}/workshop/suppliers`;
	},

	uriVehicles(id = "") {
		return `${API_URL}/vehicles/${id}`;
	},

	uriExpensesTypes(id = "") {
		return `${API_URL}/cost-types/${id}`;
	},

	uriWorksheets(id = "") {
		return `${API_URL}/worksheets/${id}`;
	},

	uriWorkshopParts(id = "") {
		return id ? `${API_URL}/workshop/parts/${id}` : `${API_URL}/workshop/parts`;
	},

	uriPartsRecalculateStock() {
		return `${API_URL}/workshop/parts/recalculate-stock`;
	},

	uriWorkshopPartMovements(id = "") {
		return `${API_URL}/workshop/parts/${id}/movements`;
	},

	uriWorkshopSupplierPurchases(id = "") {
		return `${API_URL}/workshop/suppliers/${id}/purchases`;
	},

	uriWorkshopPurchases(id = "") {
		return id ? `${API_URL}/workshop/purchases/${id}` : `${API_URL}/workshop/purchases`;
	},

	uriWorkshopStock(id = "") {
		return id ? `${API_URL}/workshop/stock/${id}` : `${API_URL}/workshop/stock`;
	},

	uriWorkshopInterventions(id = "") {
		return id ? `${API_URL}/workshop/interventions/${id}` : `${API_URL}/workshop/interventions`;
	}
};
